import { Pills } from '../components/Pill';
import { Prompt } from '../components/Prompt';
import { SectionHeader } from '../components/SectionHeader';
import { TerminalWindow } from '../components/TerminalWindow';
import { site, yearsCoding } from '../data/site';
import styles from './About.module.css';

const PILLS = [
  'Microsoft Certified Professional',
  'Software analysis',
  'High-demand architecture',
  'PCI DSS',
  'CMMC compliance',
  'Legacy modernization',
];

export function About() {
  const years = yearsCoding();

  /** Rendered like a key = value config file. */
  const about: ReadonlyArray<[key: string, value: string]> = [
    ['name', site.name],
    ['founded', `${site.foundedYear}, ${site.location}`],
    ['experience', `${years} years, since ${site.experienceSince}`],
    ['focus', 'Software analysis, architecture for high-demand systems'],
    ['certs', 'Microsoft Certified Professional'],
    ['compliance', 'PCI DSS, CMMC'],
    ['migrations', 'Legacy systems to modern platforms'],
    ['shell', "/bin/bash (and PowerShell, when nobody's looking)"],
    ['plan', 'Build software that survives Monday mornings.'],
  ];

  return (
    <section id="about" className="band">
      <div className="container split">
        <div className={styles.left}>
          <SectionHeader loose prompt="$ cat /etc/seaxdev/about" title="About" />
          <p className="copy">
            SeaxDev is a new software studio in Massachusetts, built on {years} years of hands-on
            experience designing and running software for high-demand systems.
          </p>
          <p className="copy">
            We bring deep experience in software analysis and in architecting systems that stay
            fast, stable and maintainable when the load goes up.
          </p>
          <p className="copy">
            We have worked under the Payment Card Industry Data Security Standard (PCI DSS) and CMMC
            compliance, and have led migrations from legacy systems to modern platforms.
          </p>
          <Pills items={PILLS} aria-label="Credentials" />
        </div>

        <TerminalWindow title="seax@dev: ~" className={styles.right} bodyClassName={styles.body}>
          <Prompt className={styles.prompt}>cat /etc/seaxdev/about</Prompt>
          <dl className={styles.grid}>
            {about.map(([key, value]) => (
              <div key={key} className={styles.row}>
                <dt className={styles.label}>{key}</dt>
                <dd className={styles.value}>{value}</dd>
              </div>
            ))}
          </dl>
        </TerminalWindow>
      </div>
    </section>
  );
}
